import {
  RiArchiveLine,
  RiHistoryLine,
  RiLightbulbLine,
  RiLinksLine,
  RiQuestionLine,
  RiRadarLine,
  RiTimeLine,
  RiUserStarLine,
} from 'react-icons/ri';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { ScrollArea } from './ui/scroll-area';
import { TargetsPanel } from './panels/TargetsPanel';
import { CollectPanel } from './panels/CollectPanel';
import { EntitiesPanel } from './panels/EntitiesPanel';
import { EvidencePanel } from './panels/EvidencePanel';
import { TimelinePanel } from './panels/TimelinePanel';
import { RequirementPanel } from './panels/RequirementPanel';
import { HypothesesPanel } from './panels/HypothesesPanel';
import { AuditPanel } from './panels/AuditPanel';

const TABS = [
  { value: 'targets', label: '对象', icon: RiUserStarLine },
  { value: 'collect', label: '检索', icon: RiRadarLine },
  { value: 'entities', label: '线索', icon: RiLinksLine },
  { value: 'evidence', label: '证据', icon: RiArchiveLine },
  { value: 'timeline', label: '时间线', icon: RiTimeLine },
  { value: 'requirements', label: '需求', icon: RiQuestionLine },
  { value: 'assess', label: '研判', icon: RiLightbulbLine },
  { value: 'log', label: '日志', icon: RiHistoryLine },
] as const;

export function CaseFilePanel() {
  return (
    <aside className="app-panel flex min-h-0 w-[364px] shrink-0 flex-col border-r border-border">
      <Tabs defaultValue="targets" className="flex min-h-0 flex-1 flex-col">
        <TabsList className="shrink-0 gap-0 overflow-x-auto">
          {TABS.map(tab => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="shrink-0 flex-col gap-0.5 px-2 py-1.5"
            >
              <tab.icon className="size-3.5" />
              <span className="text-[10px]">{tab.label}</span>
            </TabsTrigger>
          ))}
        </TabsList>

        {[
          { value: 'targets', node: <TargetsPanel /> },
          { value: 'collect', node: <CollectPanel /> },
          { value: 'entities', node: <EntitiesPanel /> },
          { value: 'evidence', node: <EvidencePanel /> },
          { value: 'timeline', node: <TimelinePanel /> },
          { value: 'requirements', node: <RequirementPanel /> },
          { value: 'assess', node: <HypothesesPanel /> },
          { value: 'log', node: <AuditPanel /> },
        ].map(item => (
          <TabsContent key={item.value} value={item.value} className="min-h-0 flex-1">
            <ScrollArea className="h-full">{item.node}</ScrollArea>
          </TabsContent>
        ))}
      </Tabs>
    </aside>
  );
}